import { render, staticRenderFns } from "./CheckboxFieldPreview.vue?vue&type=template&id=21d217da&scoped=true"
import script from "./CheckboxFieldPreview.vue?vue&type=script&lang=js"
export * from "./CheckboxFieldPreview.vue?vue&type=script&lang=js"
import style0 from "./CheckboxFieldPreview.vue?vue&type=style&index=0&id=21d217da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d217da",
  null
  
)

export default component.exports